export const COLORS = {
  navy: 0x082d57,
  orange: 0xef5a17,
  green: 0x61aa45,
  sky: 0x70bde6,
  cream: 0xfff7e8,
  yellow: 0xf9b71b,
  teal: 0x5db7b0,
  concrete: 0xb8bdc4,
};

const photo = name => `${import.meta.env.BASE_URL}assets/photos/${name}`;

export const PHOTOS = [
  {
    src: photo("tpac-plaza-wide-v2.jpg"),
    title: "球劇場與一樓廣場",
    credit: "Supanut Arunoprayote · CC BY 4.0",
    url: "https://commons.wikimedia.org/wiki/File:Taipei_Performing_Arts_Center_07.23_(2).jpg",
  },
  {
    src: photo("tpac-globe-street-v2.jpg"),
    title: "球劇場街道視角",
    credit: "Supanut Arunoprayote · CC BY 4.0",
    url: "https://commons.wikimedia.org/wiki/File:TPAC_Globe_Playhouse_and_bus_shelters_20230730.jpg",
  },
  {
    src: photo("tpac-exterior-2023-v2.jpg"),
    title: "場館與捷運高架",
    credit: "臺北市政府觀光傳播局 · 政府網站資料開放宣告",
    url: "https://commons.wikimedia.org/wiki/File:Taipei_Performing_Arts_Center_2023.jpg",
  },
  {
    src: photo("tpac-city-view-v2.jpg"),
    title: "建築量體空拍",
    credit: "臺北市政府工務局大地工程處 · 政府網站資料開放宣告",
    url: "https://commons.wikimedia.org/wiki/File:Taipei_Performing_Arts_Center_20221215_(cropped).jpg",
  },
  {
    src: photo("tpac-jiantan-context-v2.jpg"),
    title: "劍潭站與基地脈絡",
    credit: "Tzuhsun Hsu · CC BY-SA 2.0",
    url: "https://commons.wikimedia.org/wiki/File:Taipei_Performing_Arts_Center_and_Jiantan_Station_20221127.jpg",
  },
  {
    src: photo("tpac-night-v2.jpg"),
    title: "夜間城市遠景",
    credit: "4300streetcar · CC BY 4.0",
    url: "https://commons.wikimedia.org/wiki/File:Taipei_Performing_Arts_Center_at_night_from_Mount_Jiantan_April_2026.jpg",
  },
  {
    src: photo("reference-market-tents-v2.jpg"),
    title: "活動帳篷骨架與人流",
    credit: "USDAgov · Public Domain",
    url: "https://commons.wikimedia.org/wiki/File:2016_USDA_Farmers_Market_(20161028-AMS-LSC-0162).jpg",
  },
  {
    src: photo("reference-food-truck-v2.jpg"),
    title: "餐車活動密度參考",
    credit: "Selena N. B. H. · CC BY 2.0",
    url: "https://commons.wikimedia.org/wiki/File:Food_Truck_rodeo,_Asheville_NC_March_2016.jpg",
  },
];

export const CHAPTERS = [
  { title: "整體鳥瞰", copy: "依企畫第 38 頁配置，將三個廣場、場館本體與八類活動設施放進同一個可行走場景。", metrics: ["3 個廣場", "約 1,826 坪", "8 類設施"], position: [102, 78, 116], target: [0, 5, 5], photo: 3 },
  { title: "歡迎回家入口", copy: "從捷運劍潭站方向進場，先看見大型家門與鑰匙意象；入口前保留清楚集散空間。", metrics: ["南側主入口", "拍照打卡", "集章起點"], position: [10, 6.5, 69], target: [0, 2.4, 57], photo: 2 },
  { title: "互動遊戲區", copy: "房屋窗景、記憶翻牌、品牌拼圖與萬人共築新 LOGO 集中在入口後方，形成親子第一站。", metrics: ["4 組互動", "親子友善", "排隊可視化"], position: [20, 5.5, 54], target: [0, 2, 43], photo: 0 },
  { title: "品牌與外部市集", copy: "3×3 米米白帳沿環場動線分區排列，保留主通道，不遮蔽建築入口與重要視線。", metrics: ["3×3 m 單帳", "統一識別", "雙側逛遊"], position: [60, 7, 42], target: [40, 2, 29], photo: 6 },
  { title: "主舞台與觀眾區", copy: "舞台依企畫尺寸 6×4×0.3 米配置，正面留出觀眾與休息區，背面配置工作與音響動線。", metrics: ["6×4 m", "高 0.3 m", "燈光音響"], position: [-66, 5.8, 13], target: [-54, 2.2, 1], photo: 0 },
  { title: "休息與用餐", copy: "木棧板模組座位分布在舞台及東側餐車附近，讓親子可短暫停留又不阻斷逛遊動線。", metrics: ["模組家具", "木質核心", "鄰近餐車"], position: [-36, 5.6, 30], target: [-46, 1.3, 18], photo: 7 },
  { title: "餐車與後勤", copy: "餐車靠場邊配置，流動廁所置於北西側；服務台位於核心動線，可快速回應活動需求。", metrics: ["一般＋無障礙", "後勤在外圈", "服務台置中"], position: [-62, 5.5, -22], target: [-51.5, 1.2, -32], photo: 7 },
];
